export const invoicesMisc = {
  sendLink: {
    title: "Enviar link de facturación",
    already: {
      title: "Esta reserva ya tiene una factura emitida.",
      onlyOne: "Solo se permite <b>1 factura por reserva</b>.",
      offerPdf:
        "Si quieres, podemos enviarte ahora mismo el PDF de la factura por WhatsApp.",
    },
    openPdf: "Abrir PDF",
    sendWhatsapp: "Enviar factura por WhatsApp",
    sending: "Enviando...",
    info: {
      title: "Se enviará el link de facturación al huésped por WhatsApp.",
      desc: "El huésped completará sus datos fiscales desde el link y podrá descargar su factura electrónica.",
    },
    rule: "<strong>Regla:</strong> solo se puede emitir <b>1 factura por reserva</b>.",
    accept: "Aceptar y enviar",
    toast: {
      invoiceSent: "Factura enviada por WhatsApp.",
      linkSent: "Link de facturación enviado por WhatsApp.",
    },
    warn: {
      noReservation: "No se encontró el ID de la reserva todavía.",
    },
    err: {
      sendInvoiceFailed: "No se pudo enviar la factura por WhatsApp.",
      sendLinkFailed: "No se pudo enviar el link.",
    },
  },
  country: {
    placeholder: "Selecciona un país (opcional)",
    noResult: "Sin resultados",
  },
  adjust: {
    title: "Ajustar {name}",
    type: {
      apartment: "Apartamento(s)",
      hotel: "Hotel (Habitaciones)",
      villa: "Villas",
      camping: "Campings",
      default: "Alojamientos",
    },
    usage: "Uso actual",
    available: "Disponibles",
    unitDefault: "unid.",
    hintReduce:
      "La reducción se aplica ahora y <b>no</b> genera reembolso. Pagarás menos en la próxima factura.",
    unitPriceCurrent: "Precio unitario vigente",
    totalBeforeProration: "Total (antes de prorrateo)",
    prorationNote:
      "Se hará un <b>prorrateo</b> por los días cumplidos del ciclo.",
    confirmIncrease: "Confirmar aumento",
    confirmDecrease: "Confirmar reducción",
    err: {
      selectAmount: "Selecciona una cantidad a ajustar.",
      failed: "No se pudo completar la operación.",
    },
    toast: {
      added: "Unidades añadidas",
      reduced: "Unidades reducidas",
      addedDetail: "Se aplicará un prorrateo por los días restantes del ciclo.",
      reducedDetail: "Se pagará menos en la próxima factura (sin reembolso).",
    },
  },
  menu: {
    title: "Mi Suscripción",
    subtitle: "Gestiona tus suscripciones facturas y métodos de pago",
    subscription: "Mi suscripción",
    paymentMethod: "Método de pago",
    invoices: "Facturas",
  },
  custom: {
    title: "Plan Personalizado",
    whatDoYouNeed: "¿Que necesitas?",
    salesContact:
      "Nuestro equipo de ventas se pondrá en contacto contigo lo más rápido posible.",
    tellUs: "Cuéntanos más acerca de tu proyecto",
    sentOk: "Se envió correctamente",
    salesContactShort:
      "El equipo de ventas se pondrá en contacto lo mas rápido posible",
    contactSales: "Contactar con ventas",
    err: {
      required:
        "Debe especificar lo que necesita para poder comunicarnos con usted",
      failed: "Disculpe no se pudo procesar la solicitud",
    },
  },
  common: {
    cancel: "Cancelar",
    close: "Cerrar",
  },
};
